import { ProductGetDTO } from 'svila-common';
import { AxiosResponse } from 'axios';
import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  get: async (id) => {
    return request(`${API_URL}/products/products/${id}`, 'get');
  },
  update: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/products/products/${id}`, 'put', body);
  },
  getByBarcode: async (barcode) => {
    return request(`${API_URL}/products/products/get-by-baracode/${barcode}`, 'get');
  },
  create: async (genericId, manufacturerId) => {
    return request(`${API_URL}/products/products/${genericId}/${manufacturerId}`, 'post');
  },
  delete: async (id) => {
    return request(`${API_URL}/products/products/${id}`, 'delete');
  },

  // getSupplierProductHats: async (id) => {
  //   return request(`${API_URL}/products/generics/${id}/suppliers/get`, 'post', {}, {});
  // },

  createRemoveProducts: async (id, manufacturers) => {
    const body = JSON.stringify(manufacturers);
    return request(`${API_URL}/products/products/${id}`, 'post', body);
  },
  swapManufacturer: async (id, manufacturerId) => {
    return request(`${API_URL}/products/products/swap-manufacturer/${id}/${manufacturerId}`, 'post');
  },
  analizePackings: async () => {
    return request(`${API_URL}/products/analyses/analize-packings`, 'get');
  },

  analizeProducts: async (): Promise<AxiosResponse<any>> => {
    return request(`${API_URL}/products/analyses`, 'get');
  },

  // updateUniqueProducts: async (id, supplierId, manufacturerIds) => {
  //   const body = JSON.stringify(manufacturerIds);
  //   return request(`${API_URL}/products/generics/${id}/suppliers/${supplierId}/uniqueProducts`, 'post', body, {});
  // },
  merge: async (dto) => {
    const body = JSON.stringify(dto);

    return request(`${API_URL}/products/products/merge`, 'post', body);
  },
  resetLayout: async (id: string): Promise<AxiosResponse<ProductGetDTO>> => {
    return request(`${API_URL}/products/products/clear-layout/${id}`, 'get');
  },
};
